import { booleanAttribute, Component, Input } from '@angular/core';
import {
  ResponseState,
  ActivityType,
  HistoryType,
} from '@fullyops/legacy/data';
import { ComponentInOutAnimation } from '@fullyops/shared/util/component-base-animation';
import { PermissionType } from '@fullyops/legacy/ui/ui-shared/utils/crm-types';
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { HistoryItem } from '@fullyops/data/history/history';
import { MaterialModule } from '@fullyops/shared/material.module';
import { SharedModule } from '@fullyops/shared/shared.module';
import { HistoryActivityComponent } from '../history-activity/history-activity.component';
import {
  HistoryTicketComponent,
  OpenTicketEvent,
} from '../history-ticket/history-ticket.component';
import { I18NextModule } from 'angular-i18next';
import { AnnotateWithCompletedFlagPipe } from '@fullyops/shared/pipes/annotate-with-completed-flag.pipe';
import { ExpansionPanelComponent } from '../expansion-panel/expansion-panel.component';
import { Router } from '@angular/router';

@Component({
  selector: 'crm-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  animations: [ComponentInOutAnimation.AnimTrigger],
  standalone: true,
  imports: [
    SharedModule,
    MaterialModule,
    I18NextModule,
    HistoryActivityComponent,
    HistoryTicketComponent,
    AnnotateWithCompletedFlagPipe,
    ExpansionPanelComponent,
  ],
})
export class HistoryComponent {
  @Input() history: HistoryItem[];
  /** Just the timeline, for a container with its own title; whoever shows it checks CAN_ACCESS_HISTORY. */
  @Input({ transform: booleanAttribute }) bare = false;

  state = ResponseState;
  activityType = ActivityType;
  historyPermissions = [PermissionType.CAN_ACCESS_HISTORY];

  constructor(private router: Router) {}

  protected onOpenActivity(activityId: string) {
    this.router.navigate(['/activities', activityId, 'edit']);
  }

  protected onOpenTicket({ ticketType, ticketId }: OpenTicketEvent) {
    this.router.navigate([
      '/tickets',
      ticketType.toLowerCase(),
      ticketId,
      'edit',
    ]);
  }
}
